import {withNavigationWatcher} from './contexts/navigation';
import GestionClient from "./pages/gestion-client/gestionclient";
import GestionPermission from "./pages/gestion-permissions/gestion-permission";
import GestionMessages from './pages/gestion-messages/gestion-messages';
import GestionUnites from './pages/gestion-unites/gestion-unites';
import GestionPlans from './pages/gestion-plans/gestion-plans';
import GestionTaxes from './pages/gestion-taxes/gestion-taxes';
import GestionPromotions from './pages/gestion-promotions/gestion-promotions';
import GestionRecettes from './pages/gestion-recettes/gestion-recettes';
import GestionFolios from './pages/gestion-folios/gestion-folios';
import GestionTypesServices from './pages/gestion-types-services/gestion-types-services';
import GestionTypesEquipements from './pages/gestion-types-equipements/gestion-types-equipements';
import GestionGroupesTypesUnites from './pages/gestion-groupes-types-unites/gestion-groupes-types-unites';
import GestionCategoriesUnites from './pages/gestion-categories-unites/gestion-categories-unites';
import GestionTypesPaiements from './pages/gestion-types-paiements/gestion-types-paiements';
import GestionInstitutionsFinancieres from './pages/gestion-institutions-financieres/gestion-institutions-financieres';
import GestionCatalogueProduits from './pages/gestion-catalogue-produits/gestion-catalogue-produits';
import GestionPosteEnregistrement from './pages/gestion-poste-enregistrement/gestion-poste-enregistrement';
import GestionGroupesChasseurs from './pages/gestion-groupes-chasseurs/gestion-groupes-chasseurs';
import GestionCorrectionVilles from './pages/gestion-correction-villes/gestion-correction-villes';
import GestionMontantsDus from './pages/gestion-montants-dus/gestion-montants-dus';
import GestionActivites from './pages/gestion-activites/gestion-activites';
import GestionCaches from './pages/gestion-caches/gestion-caches';
import GestionCommandites from './pages/gestion-commandites/gestion-commandites';
import GestionEspeces from './pages/gestion-especes/gestion-especes';
import GestionGibiers from './pages/gestion-gibiers/gestion-gibiers';
import GestionLieuxSejour from './pages/gestion-lieux-sejour/gestion-lieux-sejour';
import GestionPointsEau from './pages/gestion-points-eau/gestion-points-eau';
import GestionPointsVente from './pages/gestion-points-vente/gestion-points-vente';
import GestionRoulottes from './pages/gestion-roulottes/gestion-roulottes';
import GestionSecteurs from './pages/gestion-secteurs/gestion-secteurs';
import GestionTypesSejours from './pages/gestion-types-sejours/gestion-types-sejours';
import GestionTypesTransports from './pages/gestion-types-transports/gestion-types-transports';
import GestionFacturationCompteurs from './pages/gestion-facturation-compteurs/gestion-facturation-compteurs';
import GestionFacturation from "./pages/gestion-facturation/gestion-facturation";
import GestionTypesPermis from './pages/gestion-types-permis/gestion-types-permis';
import GestionTirages from './pages/gestion-tirages/gestion-tirages';
import Calendrier from "./pages/calendrier/calendrier";
import GestionModificationInventaire from './pages/gestion-modification-inventaire/gestion-modification-inventaire';
import GestionEntreprises from './pages/gestion-entreprises/gestion-entreprises';
import GestionUsagers from './pages/gestion-usagers/gestion-usagers';
import GestionDepots from './pages/gestion-depots/gestion-depots';
import GestionTermesEtConditions from './pages/configuration/termesEtConditions';
import ConfigurationLangues from './pages/configuration/configuration-langues';
import ConfigurationPays from './pages/configuration/configuration-pays';
import ConfigurationProvinces from './pages/configuration/configuration-provinces';
import ConfigurationTranchesAges from './pages/configuration/configuration-tranches-ages';
// import ConfigurationCategoriesClients from './pages/configuration/configuration-categories-clients';
import ConfigurationClientsTitres from './pages/configuration/configuration-clients-titres';
import ConfigurationEnregistrements from './pages/configuration/configuration-enregistrements';
import GrandLivreJournal from './pages/grand-livre/journal';
import PopupFermeturesModules from './pages/grand-livre/popup-fermetures-modules';
import PopupGenererEcrituresOuverture from './pages/grand-livre/popup-generer-ecritures-ouverture';
import GestionContrats from './pages/gestion-contrats/gestion-contrats';
import GroupesEtatFinancier from './pages/groupes-etat-financier/groupes-etat-financier';
import GestionListeOccupants from './pages/gestion-liste-occupants/gestion-liste-occupants';
import GestionListeArrivee from './pages/gestion-liste-arrivee/gestion-liste-arrivee';
import GestionFournisseurs from './pages/fournisseurs/fournisseurs';
import GestionPaies from './pages/gestion-paies/gestion-paies';
import RaisonsAbsence from './pages/raisons-absence/raisons-absence';
import RapportsFournisseurs from './pages/rapports-fournisseurs/rapports-fournisseurs';
import RapportsReservation from './pages/rapports-reservation/rapports-reservation';
import GestionPublipostage from './pages/gestion-publipostage/gestion-publipostage';
import GestionFusionClients from './pages/gestion-fusion-clients/gestion-fusion-clients';
import GestionTypesUnites from './pages/gestion-types-unites/gestion-types-unites';
import GestionEvenements from './pages/gestion-evenements/gestion-evenements';
import RapportsTpv from './pages/rapports-tpv/rapports-tpv';
import GestionListeResidents from './pages/gestion-liste-residents/gestion-liste-residents';
import GestionCodesBarriere from './pages/gestion-codes-barriere/gestion-codes-barriere';
import ConfigurationFacturation from './pages/configuration/configuration-facturation';
import PaieMetiers from './pages/paie-metiers/paie-metiers';
import TauxCCQ from './pages/taux-ccq/taux-ccq';
import SecteursMetier from './pages/secteurs-metier/secteurs-metier';
import CompetencesMetier from './pages/competences-metier/competences-metier';
import GestionReservations from "./pages/gestion-reservations/gestion-reservations";
import ListeClients from "./rapports/liste-clients";
import RapportDeCaisse from "./rapports/rapport-de-caisse";
import DepotClients from "./rapports/depot-clients";
import ListeReservations from "./rapports/liste-reservations";
import ListeArriveeDepart from "./rapports/liste-arrivee-depart";
import ListeMenages from "./rapports/liste-menages";
import NombreNuiteesAnnuelTypeUnite from "./rapports/nombres-nuitees-annuel-type-unite";
import MontantRecevoir from "./rapports/montant-recevoir";
import ListeItemsVendus from "./rapports/liste-items-vendus";
import TauxOccupation from "./rapports/taux-occupation";
import ListeRepasUnite from "./rapports/liste-repas-unite";
import VentesFolioDetaille from "./rapports/ventes-folio-detaille";
import RapportVentesDetaille from "./rapports/rapport-ventes-detaille";
import RapportValeurInventaire from "./rapports/rapport-valeur-inventaire";
import RapportPlanificationRepas from "./rapports/rapport-planification-repas";
import JournalPaiements from "./rapports/journal-paiements";
import JournalVentes from "./rapports/journal-ventes";
import ConfigurationComptabilite from './pages/configuration/configuration-comptabilite';
import ConfigurationImprimantes from './pages/configuration/configuration-imprimantes';
import ConfigurationServeurCourriel from './pages/configuration/configuration-seveur-courriel';
import ConfigurationParametresWeb from './pages/configuration/configuration-parametres-web';
import ConfigurationMateriel from './pages/configuration/configuration-materiel';
import GestionEnregistrement from './pages/gestion-enregistrement/gestion-enregistrement';
import GestionHistoriqueEntrees from './pages/gestion-historique-entrees/gestion-historique-entrees';
import GestionChannelManager from './pages/gestion-channel-manager/gestion-channel-manager';
import AchalandagePostesEnregistrements from './rapports/achalandage-postes-enregistrements';
import AchalandageMensuelActivitésLieuxSejours from './rapports/achalandage-mensuel-activités-lieux-séjours';
import AchalandagePeriode from './rapports/achalandage-periode';
import AchalandageTypesLieuxSejour from './rapports/achalandage-type-lieux-sejour';
import AchalandageEffectuePeriode from './rapports/achalandage-effectue-periode';
import AnalyseStatiquespeche from './rapports/analyse-statiques-peche';
import FeuilletsEnregistrementsNomRemis from './rapports/feuillets-enregistrements-nom-remis';
import ListeCaches from './rapports/liste-caches';
import ListeChasseurs from './rapports/liste-chasseurs';
import ListeGroupeChasseurs from './rapports/liste-groupe-chasseurs';
import ListeMembres from './rapports/liste-membre';
import ListePassagesFQCQ from './rapports/liste-passages-fqcq';
import ListePointsEau from './rapports/liste-points-eau';
import ListeRoulottes from './rapports/liste-roulottes';
import PointsEauAFermer from './rapports/points-eau-a-fermer';
import PresencesSurTerritoire from './rapports/presences-sur-territoire';
import QuotasPointsEau from './rapports/quotas-points-eau';
import StatistiquesCaptures from './rapports/statistiques-captures';
import StatistiquesPrises from './rapports/statistiques-prises';
import StatistiquesDePrisesDePecheParTypeDeSejours from './rapports/statistiques-prises-peche-type-sejours';
import StatistiquesFichiersEnregistrement from './rapports/statistiques-fichers-enregistrement';
import ImpressionConfirmation from "./pages/gestion-reservations/impression-confirmation";
import GestionPromotionCondition from './pages/gestion-promotions/gestion-promotion-condition';
import ConfigurationApplication from './pages/configuration/configuration-application';
import ConfigurationReservation from './pages/configuration/configuration-reservation';
import DefinitionColonnesDePlansParDefaut from './pages/configuration/definitions/definition-colonnes-plans';
import GestionCalculateurTarifsWeb from './pages/gestion-calculateur-tarifs-web/gestion-calculateur-tarifs-web';
import GestionTransfertAcomba from './pages/gestion-transfert-acomba/gestion-transfert-acomba';
import Wubook from './pages/synchronisation/wubook';
import GestionSchemas from './pages/gestion-schemas/gestion-schemas';

const routes = [
    {
        path: 'calendrier',
        element: Calendrier
    },
    {
        path: 'gestion-client',
        element: GestionClient
    },
    {
        path: "gestion-types-services",
        element: GestionTypesServices
    },
    {
        path: "gestion-usagers",
        element: GestionUsagers
    },
    {
        path: "gestion-entreprises",
        element: GestionEntreprises
    },
    {
        path: "gestion-depots",
        element: GestionDepots
    },
    {
        path: "gestion-liste-residents",
        element: GestionListeResidents
    },
    {
        path: "gestion-groupes-types-unites",
        element: GestionGroupesTypesUnites
    },
    {
        path: "gestion-permissions",
        element: GestionPermission
    },
    {
        path: "gestion-categories-unites",
        element: GestionCategoriesUnites
    },
    {
        path: "gestion-messages",
        element: GestionMessages
    },
    {
        path: "gestion-unites",
        element: GestionUnites
    },
    {
        path: "gestion-types-unites",
        element: GestionTypesUnites
    },
    {
        path: "gestion-evenements",
        element: GestionEvenements
    },
    {
        path: "gestion-plans",
        element: GestionPlans
    },
    {
        path: "gestion-taxes",
        element: GestionTaxes
    },
    {
        path: "gestion-types-paiements",
        element: GestionTypesPaiements
    },
    {
        path: "gestion-institutions-financieres",
        element: GestionInstitutionsFinancieres
    },
    {
        path: "gestion-catalogue-produits",
        element: GestionCatalogueProduits
    },
    {
        path: "gestion-modification-inventaire",
        element: GestionModificationInventaire
    },
    {
        path: "gestion-poste-enregistrement",
        element: GestionPosteEnregistrement
    },
    {
        path: "gestion-groupes-chasseurs",
        element: GestionGroupesChasseurs
    },
    {
        path: "gestion-promotions",
        element: GestionPromotions
    },
    {
        path: "gestion-publipostage",
        element: GestionPublipostage
    },
    {
        path: "gestion-fusion-clients",
        element: GestionFusionClients
    },
    {
        path: "gestion-correction-villes",
        element: GestionCorrectionVilles
    },
    {
        path: "gestion-montants-dus",
        element: GestionMontantsDus
    },
    {
        path: "gestion-recettes",
        element: GestionRecettes
    },
    {
        path: "gestion-folios",
        element: GestionFolios
    },
    {
        path: "gestion-enregistrements",
        element: GestionEnregistrement
    },
    {
        path: "gestion-historique-entrees",
        element: GestionHistoriqueEntrees
    },
    {
        path: "gestion-channel-manager",
        element: GestionChannelManager
    },
    {
        path: "gestion-activites",
        element: GestionActivites
    },
    {
        path: 'achalandage-postes-enregistrements',
        element: AchalandagePostesEnregistrements
    },
    {
        path: 'achalandage-mensuel-activites-lieux-sejours',
        element: AchalandageMensuelActivitésLieuxSejours
    },
    {
        path: 'achalandage-periode',
        element: AchalandagePeriode
    },
    {
        path: 'achalandage-types-lieux-sejour',
        element: AchalandageTypesLieuxSejour
    },
    {
        path: 'achalandage-effectue-periode',
        element: AchalandageEffectuePeriode
    },
    {
        path: 'analyse-statiques-peche',
        element: AnalyseStatiquespeche
    },
    {
        path: 'feuillets-enregistrements-nom-remis',
        element: FeuilletsEnregistrementsNomRemis
    },
    {
        path: 'liste-caches',
        element: ListeCaches
    },
    {
        path: 'liste-chasseurs',
        element: ListeChasseurs
    },
    {
        path: 'liste-groupe-chasseurs',
        element: ListeGroupeChasseurs
    },
    {
        path: 'liste-membres',
        element: ListeMembres
    },
    {
        path: 'liste-passages-fqcq',
        element: ListePassagesFQCQ
    },
    {
        path: 'liste-points-eau',
        element: ListePointsEau
    },
    {
        path: 'liste-roulottes',
        element: ListeRoulottes
    },
    {
        path: 'points-eau-a-fermer',
        element: PointsEauAFermer
    },
    {
        path: 'presences-sur-territoire',
        element: PresencesSurTerritoire
    },
    {
        path: 'quotas-points-eau',
        element: QuotasPointsEau
    },
    {
        path: 'statistiques-captures',
        element: StatistiquesCaptures
    },
    {
        path: 'statistiques-prises',
        element: StatistiquesPrises
    },
    {
        path: 'statistiques-prises-pêche-type-sejours',
        element: StatistiquesDePrisesDePecheParTypeDeSejours
    },
    {
        path: 'statistiques-fichiers-enregistrement',
        element: StatistiquesFichiersEnregistrement
    },
    {
        path: "gestion-calculateur-tarifs-web",
        element: GestionCalculateurTarifsWeb
    },
    {
        path: "gestion-caches",
        element: GestionCaches
    },
    {
        path: "gestion-commandites",
        element: GestionCommandites
    },
    {
        path: "gestion-especes",
        element: GestionEspeces
    },
    {
        path: "gestion-gibiers",
        element: GestionGibiers
    },
    {
        path: "gestion-lieux-sejour",
        element: GestionLieuxSejour
    },
    {
        path: "gestion-points-eau",
        element: GestionPointsEau
    },
    {
        path: "gestion-points-vente",
        element: GestionPointsVente
    },
    {
        path: "gestion-roulottes",
        element: GestionRoulottes
    },
    {
        path: "gestion-secteurs",
        element: GestionSecteurs
    },
    {
        path: "gestion-types-equipements",
        element: GestionTypesEquipements
    },
    {
        path: "gestion-liste-occupants",
        element: GestionListeOccupants
    },
    {
        path: "gestion-liste-arrivee",
        element: GestionListeArrivee
    },
    {
        path: "gestion-types-sejours",
        element: GestionTypesSejours
    },
    {
        path: "gestion-evenements",
        element: GestionEvenements
    },
    {
        path: "gestion-types-transports",
        element: GestionTypesTransports
    },
    {
        path: "gestion-facturation-compteurs",
        element: GestionFacturationCompteurs
    },
    {
        path: "gestion-facturation",
        element: GestionFacturation
    },
    {
        path: "gestion-types-permis",
        element: GestionTypesPermis
    },
    {
        path: "gestion-transfert-acomba",
        element: GestionTransfertAcomba
    },
    {
        path: "gestion-tirages",
        element: GestionTirages
    },
    {
        path: "rapports-tpv",
        element: RapportsTpv
    },
    {
        path: "gestion-codes-barriere",
        element: GestionCodesBarriere
    },
    {
        path: "paie-metiers",
        element: PaieMetiers
    },
    {
        path: "taux-ccq",
        element: TauxCCQ
    },
    {
        path: "competences-metier",
        element: CompetencesMetier
    },
    {
        path: "configuration-application",
        element: ConfigurationApplication
    },
    {
        path: "configuration-reservation",
        element: ConfigurationReservation
    },
    {
        path: "secteurs-metier",
        element: SecteursMetier
    },
    {
        path: "rapports-reservation",
        element: RapportsReservation
    },
    {
        path: "gestion-reservation",
        element: GestionReservations
    },
    {
        path: "depot-clients",
        element: DepotClients
    },
    {
        path: "journal-paiements",
        element: JournalPaiements
    },
    {
        path: "journal-ventes",
        element: JournalVentes
    },
    {
        path: "liste-clients",
        element: ListeClients
    },
    {
        path: "liste-items-vendus",
        element: ListeItemsVendus
    },
    {
        path: "liste-reservations",
        element: ListeReservations
    },
    {
        path: "liste-arrivee-depart",
        element: ListeArriveeDepart
    },
    {
        path: "rapport-de-caisse",
        element: RapportDeCaisse
    },
    {
        path: "taux-occupation",
        element: TauxOccupation
    },
    {
        path: "liste-repas-unite",
        element: ListeRepasUnite
    },
    {
        path: "ventes-folio-detaille",
        element: VentesFolioDetaille
    },
    {
        path: "rapport-ventes-detaille",
        element: RapportVentesDetaille
    },
    {
        path: "rapport-valeur-inventaire",
        element: RapportValeurInventaire
    },
    {
        path: "rapport-planification-repas",
        element: RapportPlanificationRepas
    },
    {
        path: "liste-menages",
        element: ListeMenages
    },
    {
        path: "nombres-nuitees-annuel-type-unite",
        element: NombreNuiteesAnnuelTypeUnite
    },
    {
        path: "montant-recevoir",
        element: MontantRecevoir
    },
   {
        path: "terme-condition",
        element: GestionTermesEtConditions
    },
    {
        path: "configuration-langues",
        element: ConfigurationLangues
    },
    {
        path: "configuration-pays",
        element: ConfigurationPays
    },
    {
        path: "configuration-provinces",
        element: ConfigurationProvinces
    },
    {
        path: "configuration-tranches-ages",
        element: ConfigurationTranchesAges
    },
    // {
    //     path: "configuration-categories-clients",
    //     element: ConfigurationCategoriesClients
    // },
    {
        path: "configuration-clients-titres",
        element: ConfigurationClientsTitres
    },
    {
        path: "configuration-enregistrements",
        element: ConfigurationEnregistrements
    },
    {
        path: "configuration-facturation",
        element: ConfigurationFacturation
    },
    {
        path: "configuration-comptabilite",
        element: ConfigurationComptabilite
    },
    {
        path: "configuration-imprimantes",
        element: ConfigurationImprimantes
    },
    {
        path: "configuration-serveur-courriel",
        element: ConfigurationServeurCourriel
    },
    {
        path: "configuration-parametres-web",
        element: ConfigurationParametresWeb
    },
    {
        path: "configuration-materiel",
        element: ConfigurationMateriel
    },
    {
        path: "grand-livre-journal",
        element: GrandLivreJournal
    },
    {
        path: "grand-livre-fermetures-modules",
        element: PopupFermeturesModules
    },
    {
        path: "grand-livre-etat-financier",
        element: GroupesEtatFinancier
    },
    {
        path: "grand-livre-generer-ecritures-ouverture",
        element: PopupGenererEcrituresOuverture
    },
    {
        path: "grand-livre-gestion-contrats",
        element: GestionContrats
    },
    {
        path: "grand-livre-folios",
        element: GestionFolios
    },
    {
        path: "gestion-promotion-condition",
        element: GestionPromotionCondition
    },
    {
        path: "impression-confirmation-reservation",
        element: ImpressionConfirmation
    },
    {
        path: "definition-colonnes-plans",
        element: DefinitionColonnesDePlansParDefaut
    },
    {
        path: "synchronisation",
        element: Wubook
    },
    {
        path: "gestion-schemas",
        element: GestionSchemas
    },
    // Pages qu'il ne fallait pas faire
    //{
    //  path: "contribution-sante",
    //  element: ContributionSante
    //},
    //{
    //  path: "gestion-contrats",
    //  element: GestionContrats
    //},
    //{
    //  path: "gestion-csst",
    //  element: GestionCSST
    //},
    //{
    //  path: "gestion-journal",
    //  element: GestionJournal
    //},
    //{
    //  path: "gestion-releves1",
    //  element: GestionReleves1
    //},
    //{
    //  path: "gestion-syndicats",
    //  element: GestionSyndicats
    //},
    //{
    //  path: "groupes-etat-financier",
    //  element: GroupesEtatFinancier
    //},
    //{
    //  path: "taux-imposition",
    //  element: TauxImposition
    //},
    //{
    //  path: "taux-imposition-federal",
    //  element: TauxImpositionFederal
    //},
    //{
    //  path: "taux-imposition-provincial",
    //  element: TauxImpositionProvincial
    //},
    //{
    //  path: "types-assurances-emploi",
    //  element: TypesAssurancesEmploi
    //},
    //{
    //  path: "types-travails",
    //  element: TypesTravails
    //},
    //{
    //  path: "gestion-achats",
    //  element: GestionAchats
    //},
    //{
    //  path: "gestion-commandes",
    //  element: GestionCommandes
    //},
    //{
    //  path: "debourses",
    //  element: Debourses
    //},
    //{
    //  path: "gestion-employes",
    //  element: GestionEmployes
    //},
    {
        path: "gestion-fournisseurs",
        element: GestionFournisseurs
    },
    //{
    //  path: "gestion-paie",
    //  element: GestionPaie
    //},
    //{
    //  path: "raisons-absence",
    //  element: RaisonsAbsence
    //},
    //{
    //  path: "rapports-fournisseurs",
    //  element: RapportsFournisseurs
    //},
    //{
    //  path: "rapports-paie",
    //  element: RapportsPaie
    //},
    //{
    //  path: "revenus-et-deductions",
    //  element: RevenusEtDeductions
    //},
    //{
    //  path: "types-paiements-debourses",
    //  element: TypesPaiementsDebourses
    //}
];

export default routes.map(route => {
    return {
        ...route,
        element: withNavigationWatcher(route.element, route.path)
    };
});
